import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ImportDataRoutingModule } from './import-data-routing.module';
import {CalendarModule} from 'primeng/calendar';
import {CheckboxModule} from 'primeng/checkbox';
import {AutoCompleteModule} from 'primeng/autocomplete';
import {CoreModule} from '../../core/core.module';
import {TableModule} from 'primeng/table';
import {TranslateModule} from '@ngx-translate/core';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {GrowlModule} from 'primeng/growl';
import {FormsModule} from '@angular/forms';
import {ImportDataComponent} from './import-data.component';
import {DropdownModule} from 'primeng/dropdown';

@NgModule({
  imports: [
    CommonModule,
    ImportDataRoutingModule,
    CalendarModule,
    CheckboxModule,
    AutoCompleteModule,
    CoreModule,
    TableModule,
    TranslateModule,
    NgbModule,
    GrowlModule,
    FormsModule,
    DropdownModule
  ],
  declarations: [ImportDataComponent]
})
export class ImportDataModule { }



// WEBPACK FOOTER //
// /opt/app/src/app/features/import-data/import-data.module.ts